module.exports = __webpack_public_path__ + "e01fb8692c9132084f9d3ba3b84f5f6e.svg";